import package_json from '../../../package.json';
import assert from 'assert';
import { getApiVersion } from './getApiVersion';

// TODO - flip these once hbsuk becomes generally available
// const defaultLocalhostDomain = 'virtuallucyweb';
const defaultLocalhostDomain = 'hbsuk';

export function getSettingsUrl(origin = typeof window === 'undefined' ? '' : window?.location?.origin || '') {
  assert(origin, 'Expected either an explicit SETTINGS_URL in the environment or a window.location.origin');
  const { rawOriginSubDomain, originSubDomain, apiVersion } = getApiVersion(origin);

  if (rawOriginSubDomain === 'localhost') {
    const settingsUrl = process.env.SETTINGS_URL || process.env.REACT_APP_SETTINGS_URL;

    assert(settingsUrl, 'process.env.SETTINGS_URL or REACT_APP_SETTINGS_URL is required when serving from "localhost"');
    return settingsUrl;
  }

  // If we are in Storybook, return a mock response as we don't need to run the main logic
  // and it can cause issues if left in
  // This return is a URL path (ie. localhost:6006/mockResponse), not a relative path to the file location
  // @ts-ignore
  if (import.meta?.env?.STORYBOOK) return '/mockResponse.json';

  const [, domain] = origin.match(/https:\/\/.*[.](virtuallucyweb|hbsuk)[.]co[.]uk/) || [];
  assert(domain, 'origin should match "https://.*.(virtuallucyweb|hbsuk).co.uk"');

  const { settings } = package_json;

  for (const [API_SUB_DOMAIN, ORIGIN_SUB_DOMAIN] of Object.entries(settings)) {
    const RE = new RegExp(`^${ORIGIN_SUB_DOMAIN}$`);

    if (RE.test(originSubDomain)) {
      const apiSubDomain = originSubDomain.replace(RE, API_SUB_DOMAIN);
      return `https://${apiSubDomain}.${domain}.co.uk/${apiVersion}/triage-settings/${rawOriginSubDomain}.${domain}.co.uk`;
    }
  }

  return `https://nprodapi.${domain}.co.uk/${apiVersion}/triage-settings/${rawOriginSubDomain}.${domain}.co.uk`;
}

const IMPORTING_SERVER_SIDE = typeof process !== 'undefined';

if (IMPORTING_SERVER_SIDE) {
  const ORIGIN_SUB_DOMAIN = process.argv?.at(2);

  if (ORIGIN_SUB_DOMAIN) {
    // this module is run directly by the build scripts (nextDev.sh and nextBuild.sh). This has to be the last line echoed
    // by this module otherwise the build scripts will get confused
    console.log(getSettingsUrl(`https://${ORIGIN_SUB_DOMAIN}.${defaultLocalhostDomain}.co.uk`));
  }
}
